import * as React from 'react';
const IconEdit = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={30}
    fill="none"
    {...props}
  >
    {/* <path fill="#F5F5F5" d="M0 0h28v30H0z" /> */}
    {/* <path fill="#fff" d="M-496-471h906v983h-906z" /> */}
    <g
      stroke="#396DFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
    >
      <path d="M15.48 3.031 3.893 15.296c-.437.466-.86 1.383-.945 2.018l-.522 4.573c-.184 1.651 1.002 2.78 2.639 2.498l4.544-.776c.635-.113 1.525-.579 1.962-1.059l11.587-12.265c2.004-2.117 2.908-4.53-.211-7.48-3.105-2.921-5.462-1.891-7.466.226Z" />
      <path d="M13.547 5.078a8.646 8.646 0 0 0 7.692 7.268M1 29h25.404" />
    </g>
  </svg>
);
export default IconEdit;
